import PropTypes from 'prop-types'

const PublicBlankLayout = ({ children }) => (
  <div className="app main-public">
    <div id="yield" className="app-main-public-body">
      {children}
    </div>
  </div>
)

PublicBlankLayout.propTypes = {
  children: PropTypes.node,
}

export default PublicBlankLayout
